import React from 'react';
import PropTypes from 'prop-types';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import MenuBuyingGuide from '../../components/MenuBuyingGuide';

function Faq({ page }) {
  if (!page) {
    return null;
  }
  return (
    <div>
      <InsideHeader h1="Home Buyer FAQ" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <MenuBuyingGuide />
      <PageIntroBanner
        h2={get(page, 'intro_banner[0].top_headline')}
        h3={get(page, 'intro_banner[0].main_headline')}
        p={get(page, 'intro_banner[0].paragraph')}
        background={get(page, 'intro_banner[0].photo.contentUrl')}
      />
      <div className="faq-section section-pd">
        <div className="full-width-headline">
          <h2><em>Frequently Asked Questions</em></h2>
          <div className="lines" />
        </div>
        <div className="container">
          <ul>
            {
              page.faqs.map(faq => (
                <li className="row" key={faq.question}>
                  <div className="col-md-4 question">
                    <div className="question-graphic">Q</div>
                    <span>{faq.question}</span>
                  </div>
                  <div className="col-md-8 answer">
                    <div className="answer-graphic">A</div>
                    <div className="text-box" dangerouslySetInnerHTML={SanitizeHtml(faq.answer)} />
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
      <TestimonialBanner />
      <CtaBanner />
      <Footer />
    </div>
  );
}

Faq.propTypes = {
  page: PropTypes.object,
};

Faq.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'frequently_asked_questions',
})(Faq);



// WEBPACK FOOTER //
// ./src/pages/Faq/index.js